import React from 'react';
import _ from 'lodash';

import { useRackspaceAccountContext } from 'customer/context';
import { ExternalLink } from '../../../../common/ExternalLink';

const FinishSetup = ({
  setCurrentStepResult, index, stepResults, data1,
}) => {
  const selectedRoles = _.keys(_.pickBy(_.get(stepResults[index - 1], 'roles')));
  const organizationDomain = _.get(stepResults[index - 2], ['googleOrganization', 'displayName']);
  const { billing } = useRackspaceAccountContext();

  return (
    <div>
      <p>
        Upon completion, we will link the
        {' '}
        <strong>{ organizationDomain }</strong>
        {' '}
        Google Organization to your Rackspace account.
      </p>
      { !_.isEmpty(selectedRoles)
      && (
      <div>
        <p>The following roles will be granted to Rackspace on your Google organization:</p>
        <ul>
          { selectedRoles.map((role) => <li key={role}><strong>{ role }</strong></li>)}
        </ul>
      </div>
      )}
      <p>When finished, you will have an opportunity to link GCP Projects into Rackspace for management.</p>
      <div className="d-flex gap-6 mt-8">
        <input
          type="checkbox"
          id="acknowledge-tos"
          className="form-check-input"
          onChange={(e) => {
            setCurrentStepResult({ finished: e.target.checked });
          }}
        />
        <label className="form-label" htmlFor="acknowledge-tos">
          I acknowledge that I have read and accept the Rackspace
          {' '}
          <ExternalLink href="https://www.rackspace.com/information/legal/msa?_gl=1*1q7ug7b*_ga*MTE4MzMwODM2NC4xNTk2ODE2MTcy*_ga_P5J3XFCZLB*MTYyNjk1NDc5My4yMjkuMS4xNjI2OTU0ODI5LjA."> Global Services Agreement</ExternalLink>
          { billing.gcp.isResell && (
          <span>
            {' '}
            {' '}
            and the Rackspace Managed Services for GCP
            {' '}
            <ExternalLink href="https://www.rackspace.com/information/legal/optimizer-gcp">Terms and Conditions.</ExternalLink>
          </span>
          ) }
        </label>
      </div>
    </div>
  );
};

export default FinishSetup;
